<template>
    <div v-show="shown" @click="showBudget" class="budget-mobile-open">
        <img src="/img/iconos/icon_budget.svg" alt="icon_budget.svg">
    </div>
</template>

<script>
    export default {
        name: "BudgetMobileOpen",
        data() {
            return {
                shown: true
            }
        },
        methods: {
            showBudget() {
                this.$customBudget.show();
            },
            show() {
                this.shown = true;
            },
            hide() {
                this.shown = false;
            }
        },
        beforeCreate() {
            Vue.prototype.$customBudgetShowButton = this;
        }
    }
</script>

<style scoped>
    .budget-mobile-open {
        width: 2em;
        height: 2em;
        background-color: #333333;
        color: white;
        padding: 0.5em;
        line-height: 1;
        border-radius: 1em;
        position: absolute;
        z-index: 100;
        top: calc(50% - 1em);
        right: 0;
    }

    .budget-mobile-open img {
        height: 1.3em;
        margin-top: -0.2em;
    }

    @media (min-width: 992px) {
        .budget-mobile-open {
            display: none;
        }
    }
</style>
